import { GET_CURRENT_SUBJECT, SET_CURRENT_SUBJECT } from "../actions/types";


const currentSubjectReducer = (state = {}, action) => {
    switch (action.type) {
        case SET_CURRENT_SUBJECT:
            return {...state, ...action.payload};
        case GET_CURRENT_SUBJECT:
            return state;
        default:
            return state;
    }
}

export default currentSubjectReducer;